import { useCallback, useMemo } from "react";
import { ENV_VARS } from "../../config/env";

const TH_FIRST_CHAR_CODE = 3584;
const TH_LAST_CHAR_CODE = 3711;

function isThaiChar(ch) {
  const code = ch.charCodeAt(0);
  return TH_FIRST_CHAR_CODE <= code && code <= TH_LAST_CHAR_CODE;
}

export function detectLanguage(text) {
  for (const ch of text) {
    if (isThaiChar(ch)) {
      return "th";
    }
  }
  return "en";
}

export function useEnv(requiredEnvVars) {
  const envKey = useMemo(() => requiredEnvVars.sort().join("|"), [requiredEnvVars]);

  const validateEnv = useCallback(() => {
    try {
      const result = requiredEnvVars.reduce(
        (acc, key) => {
          // Access ENV_VARS object instead of process.env dynamically
          const value = ENV_VARS[key];
          if (!value) acc.missing.push(key);
          else acc.values[key] = value;
          return acc;
        },
        { missing: [], values: {} }
      );

      return {
        isValid: !result.missing.length,
        ...result,
        error: result.missing.length ? `Missing: ${result.missing.join(", ")}` : null,
      };
    } catch (error) {
      return { isValid: false, missing: [], values: {}, error: error.message };
    }
  }, [envKey]);

  return useMemo(() => validateEnv(), [validateEnv]);
}
